module.exports = __webpack_public_path__ + "static/media/2015_conf_Anatomy_of_pd_or_How_to_Find_Your_True_North.7690a036.png";